import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

interface SemicircleProgressProps {
  currentPoints: number;
  totalPoints?: number;
  className?: string;
}

const SemicircleProgress: React.FC<SemicircleProgressProps> = ({ currentPoints, totalPoints = 1000, className }) => {
  const data = {
    datasets: [
      {
        data: [currentPoints, totalPoints - currentPoints],
        backgroundColor: ["#1F7BF4", "#1f7bf414"],
        borderWidth: 5,
        circumference: 180,
        rotation: 270,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    cutout: "85%",
  };

  return (
    <div className={`w-28 xl:w-44 -my-5 ${className}`}>
      <div className="relative">
        <Doughnut data={data} options={options} />
        <div className="absolute bottom-8 xl:bottom-4 left-1/2 transform -translate-x-1/2 -translate-y-1/3">
          <p className="xl:text-3xl text-center font-semibold">{currentPoints}</p>
          <p>from {totalPoints}</p>
        </div>
      </div>
    </div>
  );
};

export default SemicircleProgress;
